<style>
	.root {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.padded {
		padding: 1.5rem;
	}
</style>
<script>
	export let padded = true;
</script>

<div class="root" class:padded={padded}><slot /></div>
